var _mask, _path, _path2, _path3, _circle, _path4, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgHr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 312,
    height: 205,
    viewBox: "0 0 312 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_3063_1060",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1.5,
    width: 310,
    height: 203,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 1,
    y: 1.5,
    width: 310,
    height: 203
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8029 197.818C5.39995 175.473 4.27795 151.944 8.52549 129.091C12.773 106.237 22.2739 84.6832 36.2782 66.1302C50.2826 47.5773 68.4072 32.533 89.2216 22.1845C110.036 11.8361 132.971 6.46669 156.216 6.50016C179.461 6.53362 202.38 11.969 223.165 22.3773C243.949 32.7857 262.031 47.8821 275.981 66.4753C289.932 85.0685 299.371 106.65 303.553 129.515C307.735 152.381 306.545 175.906 300.077 198.233L251.859 184.266C256.162 169.411 256.953 153.76 254.171 138.546C251.389 123.333 245.109 108.975 235.827 96.6041C226.545 84.2335 214.515 74.1894 200.687 67.2645C186.858 60.3395 171.609 56.7232 156.144 56.7009C140.678 56.6787 125.419 60.2511 111.571 67.1362C97.722 74.0213 85.6632 84.0307 76.3458 96.3745C67.0283 108.718 60.7071 123.059 57.8811 138.264C55.0551 153.469 55.8016 169.123 60.0617 183.99L11.8029 197.818Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8029 197.818C5.39995 175.473 4.27795 151.944 8.52549 129.091C12.773 106.237 22.2739 84.6832 36.2782 66.1302C50.2826 47.5773 68.4072 32.533 89.2216 22.1845C110.036 11.8361 132.971 6.46669 156.216 6.50016C179.461 6.53362 202.38 11.969 223.165 22.3773C243.949 32.7857 262.031 47.8821 275.981 66.4753C289.932 85.0685 299.371 106.65 303.553 129.515C307.735 152.381 306.545 175.906 300.077 198.233L251.859 184.266C256.162 169.411 256.953 153.76 254.171 138.546C251.389 123.333 245.109 108.975 235.827 96.6041C226.545 84.2335 214.515 74.1894 200.687 67.2645C186.858 60.3395 171.609 56.7232 156.144 56.7009C140.678 56.6787 125.419 60.2511 111.571 67.1362C97.722 74.0213 85.6632 84.0307 76.3458 96.3745C67.0283 108.718 60.7071 123.059 57.8811 138.264C55.0551 153.469 55.8016 169.123 60.0617 183.99L11.8029 197.818Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8029 197.818C5.39995 175.473 4.27795 151.944 8.52549 129.091C12.773 106.237 22.2739 84.6832 36.2782 66.1302C50.2826 47.5773 68.4072 32.533 89.2216 22.1845C110.036 11.8361 132.971 6.46669 156.216 6.50016C179.461 6.53362 202.38 11.969 223.165 22.3773C243.949 32.7857 262.031 47.8821 275.981 66.4753C289.932 85.0685 299.371 106.65 303.553 129.515C307.735 152.381 306.545 175.906 300.077 198.233L251.859 184.266C256.162 169.411 256.953 153.76 254.171 138.546C251.389 123.333 245.109 108.975 235.827 96.6041C226.545 84.2335 214.515 74.1894 200.687 67.2645C186.858 60.3395 171.609 56.7232 156.144 56.7009C140.678 56.6787 125.419 60.2511 111.571 67.1362C97.722 74.0213 85.6632 84.0307 76.3458 96.3745C67.0283 108.718 60.7071 123.059 57.8811 138.264C55.0551 153.469 55.8016 169.123 60.0617 183.99L11.8029 197.818Z",
    stroke: "#F6F6F6",
    strokeWidth: 10,
    mask: "url(#path-1-outside-1_3063_1060)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8107 197.846C2.41239 165.07 4.46112 130.07 17.6193 98.6141C30.7775 67.1585 54.2598 41.1244 84.1962 24.8025C114.133 8.48068 148.737 2.84507 182.305 8.82453C215.873 14.804 246.403 32.0416 268.862 57.6966L231.09 90.7633C216.148 73.6944 195.835 62.2257 173.501 58.2474C151.167 54.2691 128.144 58.0186 108.227 68.878C88.3094 79.7374 72.686 97.0586 63.9315 117.987C55.177 138.915 53.8139 162.202 60.0669 184.008L11.8107 197.846Z",
    fill: "#F48401"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 156,
    cy: 160.5,
    r: 23,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M149.377 174.717C157.185 178.564 166.572 175.472 170.345 167.815C174.119 160.156 224.607 22.046 224.607 22.046C224.607 22.046 145.849 146.225 142.075 153.885C138.302 161.542 141.573 170.872 149.377 174.717Z",
    fill: "#222222"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 156.33,
    cy: 160.641,
    r: 8,
    transform: "rotate(-153.768 156.33 160.641)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgHr);
export default __webpack_public_path__ + "static/media/img_hr.4e567302131c21dc7597e724d5ef72da.svg";
export { ForwardRef as ReactComponent };